import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  skillName: {
    color: '#fff',
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
  },
  filterRoot: {
    width: '100%',
    paddingTop: 3,
    paddingBottom: 3,
  },
  background: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundColor: theme.palette.primary.main,
    backgroundPosition: 'center center',
    height: 120,
    width: '100%',
    position: 'relative',
    cursor: 'pointer',
  },
  divider: {
    width: '60%',
    borderTop: '1px solid #ddd',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 3,
    marginTop: 3,
  },
  actionsWrapper: { width: '100%' },
  noBG: { minHeight: 0, maxHeight: 0, height: 0 },
  noProfile: { display: 'none' },
  creativeCardBackground: {
    minWidth: 60,
    maxWidth: 60,
    minHeight: 60,
    maxHeight: 60,
    borderRadius: '50%',
    border: '2px solid #fff',
    cursor: 'pointer',
    backgroundColor: '#ddd',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    position: 'relative',
    margin: 5,
  },
  profileNoBG: { marginTop: 10 },
}));
